import { render, staticRenderFns } from "./VodList.vue?vue&type=template&id=18b32356&scoped=true&"
import script from "./VodList.vue?vue&type=script&lang=js&"
export * from "./VodList.vue?vue&type=script&lang=js&"
import style0 from "./VodList.vue?vue&type=style&index=0&id=18b32356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b32356",
  null
  
)

export default component.exports